// extracted by mini-css-extract-plugin
export default {"ag-styles":"bn_g","showHideButton":"bn_PM","isOpen":"bn_PN","content":"bn_Nr"};